module.exports = __webpack_public_path__ + "static/media/connect4.bb6b0cf1.png";